import React from 'react';
import { gql } from '@apollo/client';
import { Show } from 'react-admin';
import PositionRateSettingsShow from '../shared/position-rate-settings-show/PositionRateSettingsShow';
import PositionRateSettingsShowActions from '../shared/position-rate-settings-show/PositionRateSettingsShowActions';
import { generatePositionalRateSettingsShowViewQuery } from '../utils/generatePositionalRateSettingsQuery';

const StatePositionRateSettingShow = () => (
  <Show actions={<PositionRateSettingsShowActions />}>
    <PositionRateSettingsShow />
  </Show>
);

StatePositionRateSettingShow.query = gql(
  generatePositionalRateSettingsShowViewQuery('state_position_rate_setting'),
);

export default StatePositionRateSettingShow;
